export default "__VITE_ASSET__DheKB5AU__"